import { TableColumnsType } from "antd";
import { TableCustom } from "@components/table";
import { Dayjs } from "dayjs";
import { useHttpQuery } from "@/hooks";
import { useRecoilState } from "recoil";
import { salonActiveState } from "@/components/state";
import { getRevenueOfPaymentMethodDetail, GetRevenueOfPaymentMethodDetailResponse } from "@/api";
import { useMemo } from "react";
import { formatDateTime } from "@/utils";

export interface RevenueByPaymentMethodDetailData {
    readonly id?: string;
    readonly name?: string;
    readonly value?: string;
    readonly quantity?: string;
}

interface RevenueByPaymentMethodDetailTableProps {
    readonly dateRange: [Dayjs, Dayjs];
    readonly paymentMethodId: number;
}

export function RevenueByPaymentMethodDetailTable(props: RevenueByPaymentMethodDetailTableProps) {
    const [salonActive] = useRecoilState(salonActiveState);

    const {data : revenueOfObjectTypeDetail, isFetching} = useHttpQuery(getRevenueOfPaymentMethodDetail, {
        query: {
            startDate: formatDateTime(props.dateRange[0]),
            endDate: formatDateTime(props.dateRange[1]),
            paymentMethodId: props.paymentMethodId,
            salonId: salonActive?.id ?? 0
        }
    });

    const columns = useMemo<TableColumnsType<GetRevenueOfPaymentMethodDetailResponse>>(
		() => [
			{
				key: 'salonBranchId',
				title: 'Chi nhánh',
				dataIndex: 'salonBranchId',
				render: (salonBranchId: number) =>
					salonActive?.salonBranches?.find((branch) => branch.id === salonBranchId)?.name,
			},
			{
				title: 'Số lượng',
				key: 'totalQuantity',
				dataIndex: 'totalQuantity',
				width: 250,
			},
			{
				key: 'totalRevenue',
				title: 'Doanh thu',
				dataIndex: 'totalRevenue',
				render: (value: number) => value.toLocaleString('en-US'),
				width: 150,
			},
		],
		[salonActive?.salonBranches]
	);

    return (
        <div style={{ paddingTop: 20 }}>
            <TableCustom
                loading={isFetching}
                showHeader={false}
                columns={columns}
                dataSource={revenueOfObjectTypeDetail?.items}
                showFooter={false}
            />
        </div>
    )
}
